const Documentations = () => {
  return (
    <div>
    
    <div className="flex flex-col justify-center  gap-1 max-w-[50rem] mx-auto pl-[2rem] pt-[1rem] mb-[100px] pr-[2rem]">
      <h1 className="text-[20px] font-bold">Documentation</h1>
      <p>
        Customs clearance is a complex affair when importing, exporting or simply sending or receiving a parcel. 
        When such a shipment is from a country where customs procedures are opaque, only paper-based, and/or 
        decisions are made only at the top with multiple reporting layers, it adds to the troubles. In addition 
        to that, when rules and regulations are not readily made public, it becomes nearly impossible for the trading 
        community to comply with them without adding to the costs and delays. TCS can help you with proper customs 
        compliance by preparing and filing the right documents for you.
      </p>

     
    </div>
  </div>
  );
};
  
export default Documentations;
  